import { Component, EventEmitter, Input, Output } from "@angular/core";
import { trigger, style, transition, animate } from "@angular/animations";
import { Sizes } from "../types/accordion.types";

@Component({
  selector: "ds-accordion",
  templateUrl: "./ds-accordion.component.html",
  styleUrls: ["./ds-accordion.component.scss"],
  animations: [
    trigger("slideDown", [
      transition(":enter", [
        style({ height: "0px", overflow: "hidden" }),
        animate("200ms ease-in-out", style({ height: "*" })),
      ]),
      transition(":leave", [
        style({ height: "*", overflow: "hidden" }),
        animate("200ms ease-in-out", style({ height: "0px" })),
      ]),
    ]),
  ],
})
export class DsAccordionComponent {
  @Input() label!: string;
  @Input() size: Sizes = "md";
  @Input() disabled: boolean = false;
  @Input() isOpen: boolean = false;
  @Input() maxWidth: boolean = false;
  @Output() isOpenChange = new EventEmitter<boolean>();

  constructor() {}

  toggleAccordion() {
    if (this.disabled) {
      return;
    }
    this.isOpen = !this.isOpen;
    this.isOpenChange.emit(this.isOpen);
  }
}
